import React, { createContext, useReducer, useCallback } from "react";
import axios from "axios";
const SocialLinkReducer = (state, action) => {
  switch (action.type) {
    case "SOCIALLINK_LOADING":
      return {
        ...state,
        loading: true,
        error: false,
      };

    case "GET_SOCIALLINK":
      return {
        ...state,
        loading: false,
        sociallink: action.sociallink,
        error: false,
      };

    case "SOCIALLINK_ERROR":
      return {
        ...state,

        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
export const SocialContext = createContext();
const SocialContextProvider = (props) => {
  const [link, dispatch] = useReducer(SocialLinkReducer, {
    sociallink: null,
    loading: false,
    error: false,
  });
  const getSocialLink = useCallback(() => {
    dispatch({ type: "SOCIALLINK_LOADING" });

    axios
      .get(process.env.REACT_APP_SERVER_URL + "/sociallink/allsociallink")
      .then((res) => {
        dispatch({ type: "GET_SOCIALLINK", sociallink: res.data });
      })
      .catch((err) => {
        dispatch({
          type: "SOCIALLINK_ERROR",
          error: err.response.data || { defaultError: "Something went wrong" },
        });
      });
  }, []);
  return (
    <SocialContext.Provider value={{ link, getSocialLink }}>
      {props.children}
    </SocialContext.Provider>
  );
};

export default SocialContextProvider;
